module.exports = __webpack_public_path__ + "static/img/p-1010283@2x.c7c3369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/p-1010283@2x.png
// module id = mlWf
// module chunks = 13